import type {
  Datalayer,
  DatalayerStreamSideEffect,
  GDDLEvent,
} from '@analytics/models';
import { inject, Injectable } from '@angular/core';
import type { AbTestData } from '@core/jss-models';
import { getSitecoreContextWithStatus } from '@core/jss-routing';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class SitecoreABTestSideEffect implements DatalayerStreamSideEffect {
  readonly #store = inject(Store);

  async getSitecoreABTestData() {
    const siteContext = await firstValueFrom(
      this.#store.pipe(getSitecoreContextWithStatus)
    );

    return (siteContext.context.abTestData as AbTestData[]) ?? [];
  }

  async process(event: GDDLEvent, datalayer: Datalayer) {
    if (event.event !== 'page-impression') {
      return;
    }

    const activeTests = await this.getSitecoreABTestData();

    activeTests.forEach((test) => {
      datalayer.pushEvent({
        event: 'ab-test',
        info: {
          testVariantName: test.testVariantName,
          testDataSourceName: test.testDataSourceName,
          testDataSourceId: test.testDataSourceId,
          testId: test.testId,
          testName: test.testName,
          variant: `${test.testName} | ${test.testVariantName}`,
        },
      });
    });
  }
}
